<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="visible"
    [style]="{ width: '330px' }" (onHide)="handleHide()">
    <div class="text-center fm-prompt" >
        <div class="text-black mb-1" style="font-size: 1.2rem; font-weight: 500;">
            Log In
        </div>
        <div class="fm-rubik mb-2" style="font-size: 0.85rem; font-weight: 400;">
            Log In To Your Account To Continue
        </div>
        <button class="mt-2 btn btn-apple-google" style="border: 1px solid #D0D5DD; width: 95%; padding-top: 0.714rem; padding-bottom: 0.714rem;" (click)="loginWithGoogle()" *ngIf="!isWebView">
            <img src="assets/images/login-google.png" style="height: 24px;width: 24px;margin-right: 0.5rem;" alt="">
            <span class="fm-rubik" style="font-size: 0.857rem;font-weight: 400;color: #344054;">
                Log in with Google
            </span>
        </button>
        <button class="mt-2 btn btn-apple-google" style="border: 1px solid #D0D5DD; width: 95%; padding-top: 0.714rem; padding-bottom: 0.714rem;" (click)="loginWithApple()">
            <img src="assets/images/login-apple.png" style="height: 24px;width: 20px;margin-right: 0.5rem;" alt="">
            <span class="fm-rubik" style="font-size: 0.857rem;font-weight: 400;color: #344054;">
                Log in with Apple
            </span>
        </button>
        <div class="mt-3 d-flex align-items-center customContainer">
            <p-divider class="flex-grow-1"></p-divider>
            <span class="px-3 fm-rubik" style="color: #B4B4BB; font-size: 0.7rem; font-weight: 400;">or login with
                email</span>
            <p-divider class="flex-grow-1"></p-divider>
        </div>
        <div class="mt-3 p-2 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.8rem;color: #848790;">Email</span>
            <input [(ngModel)]="loginModel.email" type="email" class="p-2 w-100 input-promo"
                style="font-size: 0.9rem;font-weight: bold;" placeholder="Name@example.com" />
        </div>
        <div class="mt-1 p-2 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.8rem;color: #848790;">Password</span>
            <br>
            <p-password [(ngModel)]="loginModel.password" [toggleMask]="true" [ngClass]="'input-promo'" class="psw-back-color" (keydown.enter)="login()"></p-password>
        </div>
        <div class="mt-1 p-2" style="text-align: center;">
            <button [disabled]="!loginModel.email || !loginModel.password" class="btn w-100 fm-prompt fw-bold btn-login"
                style="color: white;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                [style.background-color]="loginModel.email && loginModel.password ?  '#EF870A' : '#b4b4bb'"
                (click)="login()" (keydown.enter)="login()">Log in</button>
        </div>
        <div class="my-1 p-2 fm-rubik" style="text-align: center;">
            <span style="font-size: 0.857rem;font-weight: 400;color: #5D5D66;">
                You dont't have an account
            </span>
            <span class="fm-prompt" style="color: #EF870A;font-size: 1rem;font-weight: bold;cursor: pointer;"
                (click)="switchToSignup.emit()">
                Sign up
            </span>
        </div>
        <div class="my-1 p-2 fm-rubik" style="text-align: center;">
            <span class="fm-prompt" style="color: #EF870A;font-size: 1rem;font-weight: bold;cursor: pointer;"
                (click)="switchToForgotPassword.emit()">
                Forgot password?
            </span>
        </div>
    </div>
</p-dialog>
